{
  "familyId": "SWW-LEEN-ENG-STAM",
  "questions": [
    {
      "id": "SWW-LEEN-ENG-STAM-001",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Een klasgenoot zegt: 'De stam van *racen* is *rac*, want in het Nederlands halen we de stille -e altijd weg.' Welke stam is correct en waarom?",
      "context": null,
      "options": [
        "race — bij Engelse leenwoorden behoud je de Engelse spelling",
        "rac — Nederlandse regel: stille -e wordt geschrapt",
        "raac — open lettergreep, dus klinker verdubbelen",
        "races — extra -s om te onderscheiden van het zelfstandig naamwoord"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden bepaal je de stam met werkwoord min -en, maar de Engelse spelling blijft intact. Nederlandse spellingregels (klinker verdubbelen, stille -e schrappen) gelden HIER NIET.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — stam bepalen. Stap 1: Neem het werkwoord: racen. Stap 2: Haal -en af: racen − en = race. Stap 3: De Engelse spelling blijft behouden: 'race' (met -ce). De stam is 'race'. Checkstrategie: bij Engelse leenwoorden altijd de Engelse spelling behouden.",
        "solutionSteps": ["Neem het werkwoord: racen", "Haal -en eraf: racen − en = race", "Behoud de Engelse spelling: 'race' (met -ce)", "Check: klinkt het nog als het Engelse woord? ✓"],
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: werkwoord − en = race. De Engelse spelling blijft behouden.",
          "1": "De Engelse spelling is hier aangepast aan Nederlandse regels. 'Rac' mist de -e. De Engelse spelling 'race' (met -ce) blijft behouden: racen − en = race.",
          "2": "De klinker is hier verdubbeld. 'Raac' heeft een dubbele a die niet in het Engelse woord staat. De Engelse spelling is 'race' (met één a).",
          "3": "Hier is een extra letter toegevoegd. 'Races' heeft een -s die niet bij de stam hoort. De stam is gewoon: race (werkwoord − en)."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggelaten", "optionIndex": 1 },
          { "id": "sww.loanword-vowel-doubled", "label": "Klinker verdubbeld volgens NL-regels", "optionIndex": 2 },
          { "id": "sww.stem-with-extra-letter", "label": "Extra letter aan stam toegevoegd", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-002",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Een schrijver twijfelt tussen 'Ik chil' en 'Ik chill' in een zin. Welke vorm is correct voor de ik-persoon en waarom?",
      "context": null,
      "options": [
        "Ik chill — de Engelse dubbele -ll blijft behouden in de stam",
        "Ik chil — dubbele medeklinker wordt enkel volgens NL-spelling",
        "Ik chille — een -e toevoegen markeert de werkwoordsvorm",
        "Ik chillen — bij ik gebruik je het hele werkwoord"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij 'ik' gebruik je alleen de stam. De stam van 'chillen' is 'chill' (met dubbel l, Engelse spelling).", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_first_person",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — stam bij ik-vorm. Stap 1: Neem het werkwoord: chillen. Stap 2: Haal -en af: chillen − en = chill. Stap 3: De Engelse spelling blijft behouden: 'chill' (met dubbel l). Stap 4: Bij 'ik' gebruik je alleen de stam: ik chill.",
        "solutionSteps": ["Neem het werkwoord: chillen", "Haal -en eraf: chillen − en = chill (dubbel l behouden)", "Bij 'ik' gebruik je alleen de stam", "Antwoord: ik chill"],
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: chillen − en = chill (dubbel l behouden). Bij 'ik' alleen de stam.",
          "1": "De dubbele medeklinker is hier weggelaten. 'Chil' (enkel l) is de Nederlandse regel, maar bij Engelse leenwoorden behoud je de Engelse spelling: chill (dubbel l).",
          "2": "Hier is een extra -e toegevoegd aan de stam. 'Chille' is geen correcte vorm. Bij 'ik' gebruik je alleen de stam: chill (geen -e).",
          "3": "Hier is het hele werkwoord gebruikt als ik-vorm. 'Chillen' is het hele werkwoord. Bij 'ik' gebruik je alleen de stam: chill."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-double-consonant-lost", "label": "Dubbele medeklinker vernederlandst (enkel)", "optionIndex": 1 },
          { "id": "sww.stem-extra-e-added", "label": "Extra -e aan stam toegevoegd", "optionIndex": 2 },
          { "id": "sww.infinitive-instead-of-stem", "label": "Hele werkwoord gebruikt i.p.v. stam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-003",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Bekijk vier voorgestelde stammen voor 'managen'. Welke past binnen de regel 'werkwoord − en, Engelse spelling behouden'?",
      "context": null,
      "options": ["manage", "manag", "manaag", "manager"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden: werkwoord min -en = stam. Behoud de Engelse spelling: managen − en = manage.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem_manage",
      "variantIndex": 3,
      "citoDifficulty": 0.27,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — stam bepalen. Stap 1: Neem het werkwoord: managen. Stap 2: Haal -en af: managen − en = manage. Stap 3: De Engelse spelling blijft behouden: 'manage' (met -ge). Checkstrategie: klinkt de stam nog als het Engelse woord? manage ✓",
        "solutionSteps": ["Neem het werkwoord: managen", "Haal -en eraf: managen − en = manage", "Behoud de Engelse spelling: 'manage'", "Check: klinkt het als het Engelse woord? ✓"],
        "distractorExplanations": {
          "0": "Correct! Engelse leenwoorden: managen − en = manage. De Engelse spelling blijft behouden.",
          "1": "De Engelse spelling is hier aangepast. 'Manag' mist de -e. De Engelse spelling 'manage' (met -ge) blijft behouden. Misconceptie: de stam 'vernederlandsen'.",
          "2": "De klinker is hier verdubbeld. 'Manaag' heeft een dubbele a die niet in het Engelse woord staat. Behoud de Engelse spelling: manage.",
          "3": "Hier is het zelfstandig naamwoord gebruikt. 'Manager' is een persoon, niet de stam van het werkwoord. De stam is: manage (werkwoord − en)."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggelaten", "optionIndex": 1 },
          { "id": "sww.loanword-vowel-doubled", "label": "Klinker verdubbeld volgens NL-regels", "optionIndex": 2 },
          { "id": "sww.noun-instead-of-stem", "label": "Zelfstandig naamwoord i.p.v. werkwoordstam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-004",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "multiple_choice",
      "question": "Een leerling schrijft 'Hij timed altijd alles precies' en denkt dat dit klopt omdat -ed in het Engels ook gebruikt wordt. Welke vorm is correct in het Nederlands en welk denkfout maakt de leerling?",
      "context": null,
      "options": [
        "timet — Nederlandse hij-vorm krijgt -t, Engelse uitgangen gelden niet",
        "timt — eerst Engelse -e weghalen, dan -t toevoegen",
        "timed — Engelse verleden tijd-uitgang gebruiken",
        "tijmt — Engelse 'i' vernederlandsen naar 'ij'"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "De stam van 'timen' is 'time' (Engelse spelling). Bij hij/zij: stam + t = time + t = timet.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_third_person",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — hij/zij-vorm. Stap 1: De stam van 'timen' is 'time' (Engelse spelling behouden). Stap 2: Bij hij/zij voeg je -t toe aan de stam: time + t = timet. Checkstrategie: de Engelse spelling blijft intact, je voegt gewoon -t toe.",
        "solutionSteps": ["Bepaal de stam: timen → time (Engelse spelling)", "Bij hij/zij: stam + t", "time + t = timet", "Check: Engelse spelling behouden ✓"],
        "distractorExplanations": {
          "0": "Correct! Stam 'time' + t = timet. De Engelse spelling blijft behouden.",
          "1": "Hier is de stam 'vernederlandst'. 'Timt' mist de -e van de Engelse stam 'time'. Behoud de Engelse spelling: time + t = timet. Misconceptie: Nederlandse spellingregels toepassen.",
          "2": "Hier is -d gebruikt in plaats van -t. Bij hij/zij voeg je altijd -t toe (niet -d): timet. Misconceptie: de Engelse verleden tijd (-ed) verwarren met de Nederlandse vervoeging.",
          "3": "Hier is de spelling aangepast aan het Nederlands. 'Tijmt' verandert de 'i' in 'ij', maar de Engelse spelling blijft behouden: time + t = timet."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e uit stam weggelaten", "optionIndex": 1 },
          { "id": "sww.loanword-english-grammar", "label": "Engelse -ed verward met NL hij-vorm", "optionIndex": 2 },
          { "id": "sww.loanword-spelling-dutchified", "label": "Engelse spelling vernederlandst (i → ij)", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-005",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "fill_in",
      "question": "De stam van 'saven' (een Engels leenwerkwoord) wordt door drie leerlingen verschillend gespeld: 'sav', 'seef', '...'. Welke stam is correct volgens de regel 'werkwoord − en, Engelse spelling behouden'? Typ de juiste stam.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": { "acceptedAnswers": ["save"], "caseSensitive": false, "placeholder": "..." },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Engelse Leenwoorden", "content": "Bij Engelse leenwoorden: werkwoord min -en = stam. Behoud de Engelse spelling: saven − en = save.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "english_loanword_stem_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Regel: Engelse leenwoorden — stam bepalen. Neem het werkwoord 'saven' en haal -en eraf: saven − en = save. De Engelse spelling blijft behouden: 'save' (met -ve).",
        "solutionSteps": ["Neem het werkwoord: saven", "Haal -en eraf: saven − en = save", "Behoud de Engelse spelling: 'save'"]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Mogelijke fout: 'sav' (Engelse -e weggelaten)" },
          { "id": "sww.loanword-spelling-dutchified", "label": "Mogelijke fout: 'seef' (vernederlandst)" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-006",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "matching",
      "question": "Koppel elk Engels leenwerkwoord aan de correcte stam (let op: in elke stam moet de Engelse spelling behouden blijven — geen Nederlandse aanpassingen).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "racen", "right": "race" },
          { "left": "managen", "right": "manage" },
          { "left": "chillen", "right": "chill" },
          { "left": "timen", "right": "time" },
          { "left": "saven", "right": "save" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Stam = werkwoord − en",
            "content": "Bij Engelse leenwoorden: werkwoord min -en = stam. Behoud altijd de Engelse spelling (geen Nederlandse aanpassingen aan klinkers of medeklinkers).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_stem_matching",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Voor elk werkwoord: haal -en eraf, behoud de Engelse spelling. racen → race, managen → manage, chillen → chill (dubbel l!), timen → time, saven → save. De Engelse spelling met -e, -ll, etc. blijft intact.",
        "solutionSteps": [
          "Werkwoord − en = stam",
          "Behoud Engelse spelling (geen NL-aanpassingen)",
          "Let op dubbele medeklinkers (chill, niet chil)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse spelling versimpeld" },
          { "id": "sww.loanword-double-consonant-lost", "label": "Dubbele medeklinker vernederlandst" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-007",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "error_spotting",
      "question": "Vind de fouten in de Engelse leenwoorden (Engelse spelling moet behouden blijven).",
      "context": null,
      "correctAnswer": 0,
      "data": {
        "text": "Ik chil graag in het weekend. Ik sav het document altijd snel op de computer.",
        "errors": [
          { "word": "chil", "position": 1, "correction": "chill", "explanation": "De Engelse dubbele -ll blijft behouden in de stam: chill (niet chil). Nederlandse regels gelden hier niet." },
          { "word": "sav", "position": 7, "correction": "save", "explanation": "De Engelse -e blijft behouden in de stam: save (niet sav). Werkwoord min -en geeft save." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Twee vuistregels", "content": "1) Werkwoord min -en = stam. 2) Engelse spelling blijft intact (geen NL-aanpassingen aan klinkers, medeklinkers of -e).", "icon": "lightbulb" } }
      ],
      "conceptId": "english_loanword_stem_error_spotting",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Twee fouten waar de Engelse spelling is versimpeld. 'Chil' moet 'chill' zijn, de Engelse dubbele -ll blijft. 'Sav' moet 'save' zijn, de Engelse -e blijft. Vuistregel: bij Engelse leenwoorden gelden de Nederlandse spellingregels (medeklinker enkelen, stille -e schrappen) NIET.",
        "solutionSteps": [
          "Bepaal de stam: werkwoord min -en",
          "Behoud de Engelse spelling exact",
          "Geen NL-aanpassingen aan klinkers, medeklinkers of -e",
          "Vergelijk geschreven vorm met de Engelse stam"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-stripped", "label": "Engelse -e weggehaald uit stam" },
          { "id": "sww.loanword-double-consonant-lost", "label": "Engelse dubbele medeklinker enkel gemaakt" }
        ]
      }
    },
    {
      "id": "SWW-LEEN-ENG-STAM-008",
      "familyId": "SWW-LEEN-ENG-STAM",
      "module": "SpellingWW",
      "tier": 14,
      "levelCode": "M8",
      "group": 8,
      "skill": "leenwoorden",
      "subSkill": "leen_engels_stam",
      "questionType": "categorize",
      "question": "Sorteer elke stamvorm: behoudt deze de Engelse spelling, of is hij vernederlandst?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Correct (Engelse spelling)", "Fout (vernederlandst)"],
        "items": [
          { "text": "race (van racen)", "correctCategory": 0 },
          { "text": "chill (van chillen)", "correctCategory": 0 },
          { "text": "manage (van managen)", "correctCategory": 0 },
          { "text": "save (van saven)", "correctCategory": 0 },
          { "text": "rac (van racen)", "correctCategory": 1 },
          { "text": "chil (van chillen)", "correctCategory": 1 },
          { "text": "manaag (van managen)", "correctCategory": 1 },
          { "text": "seef (van saven)", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Engelse spelling behouden",
            "content": "Correcte stam: werkwoord − en, met Engelse spelling intact. Fout: klinker verdubbeld, dubbele medeklinker geënkeld, of -e weggelaten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "english_loanword_stem_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Engelse spelling behouden = correct. Vernederlandst (extra a in 'manaag', enkel l in 'chil', geen -e in 'rac', ij/ee in 'seef') = fout. De regel is altijd: werkwoord − en, en de Engelse spelling blijft staan.",
        "solutionSteps": [
          "Lees de stamvorm",
          "Vergelijk met de Engelse spelling van het werkwoord",
          "Identiek? → correct. Aangepast? → vernederlandst"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "sww.loanword-spelling-dutchified", "label": "Engelse spelling vernederlandst" },
          { "id": "sww.loanword-vowel-doubled", "label": "Klinker verdubbeld volgens NL-regel" }
        ]
      }
    }
  ]
}